export default {
  methods: {
    stringLimit(str, limit = 10, end = "...") {
      if (typeof str === "string" && str.length > limit) {
        str = str.substring(0, limit) + end;
      }
      return str;
    },
    stripTags(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    },
    formatPhone(phoneNumber) {
      const cleaned = ("" + phoneNumber).replace(/\D/g, "");

      // 380....
      const match = cleaned.match(/^(\d{2})(\d{3})(\d{3})(\d{2})(\d{2})$/);

      if (!match) {
        // 0800....
        let match2 = cleaned.match(/^(\d)(\d{3})(\d{3})(\d{3})$/);

        if (match2) {
          return `${match2[1]} (${match2[2]}) ${match2[3]}-${match2[4]}`;
        }

        return phoneNumber;
      }

      return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}-${match[5]}`;
    },
  },
};
